<template>
    <div>
        <!-- Form Modal -->
        <b-modal id="modal-season-form" ref="myModal" centered no-close-on-backdrop no-close-on-esc size="md"
            @ok="submit">
            <template #modal-header="{ close }">
                <h5 v-if="box.id === null">Receive Box</h5>
                <feather-icon class="ml-4 pr-0 cursor-pointer" icon="XIcon" size="16" @click="close()" />
            </template>

            <template #modal-footer="{ ok, cancel }">
                <b-button size="sm" variant="primary" @click="ok()" :disabled="saving">
                    <b-spinner small class="mr-1" label="Small Spinner" v-if="saving" />
                    <span v-if="!saving">Save</span>
                    <span v-if="saving">Saving...</span>
                </b-button>
                <b-button size="sm" @click="cancel()" variant="outline-secondary">Cancel</b-button>
            </template>

            <template #default="{ }">
                <b-row>
                    <b-col cols="12">
                        <b-alert show variant="danger" v-if="errosOcurs">
                            <h4 class="alert-heading">{{ errosOcurs.message }}</h4>
                            <div class="alert-body">
                                <div v-for="(messages, field) in errosOcurs.errors" :key="field">
                                    <strong>{{ field }}:</strong>
                                    <ul>
                                        <li v-for="message in messages" :key="message">{{ message }}</li>
                                    </ul>
                                </div>
                            </div>
                        </b-alert>
                    </b-col>
                </b-row>

                <validation-observer ref="dataForm" #default="{ invalid }">
                    <b-form ref="form" @submit.stop.prevent="handleCreate">
                        <b-row>
                            <!-- GRN number input -->
                            <b-col cols="12">
                                <b-form-group label-for="grn" label="ISN Number">
                                    <validation-provider #default="{ errors }" name="grn" rules="">
                                        <b-form-input id="grn" name="grn" v-model="box.grn"
                                            :state="errors.length > 0 ? false : null" size="md" required
                                            autocomplete="off" />
                                        <small class="text-danger">{{ errors[0] }}</small>
                                        <small class="text-danger" v-if="serverErrors && serverErrors.grn">{{
                                            serverErrors.grn[0] }}</small>
                                    </validation-provider>

                                    <!-- suggestions (local mock search) -->
                                    <div class="position-relative">
                                        <b-list-group v-if="grnResults.length" class="mt-1 suggestion-list">
                                            <b-list-group-item button v-for="item in grnResults" :key="item.id"
                                                @click="selectBoxNumber(item)">
                                                <div class="d-flex justify-content-between align-items-center">
                                                    <div><strong>{{ item.number }}</strong></div>
                                                    <small class="text-muted">
                                                        <span v-if="item.type === 1">Bale Ticket</span>
                                                        <span v-else-if="item.type === 2">Luggage</span>
                                                        <span v-else>Type {{ item.type }}</span>
                                                    </small>
                                                </div>
                                            </b-list-group-item>
                                        </b-list-group>

                                        <b-spinner small class="ml-2" v-if="grnLoading" label="loading..." />
                                        <small class="text-danger" v-if="grnError">{{ grnError }}</small>
                                    </div>
                                </b-form-group>
                            </b-col>
                        </b-row>

                        <b-row>
                            <b-col cols="12">
                                <b-form-group label-for="number" label="Box Number">
                                    <validation-provider #default="{ errors }" name="number" rules="">
                                        <b-form-input id="number" name="number" v-model="box.number"
                                            :state="errors.length > 0 ? false : null" size="md" required
                                            :readonly="isBoxNumberLocked" />
                                        <small class="text-danger">{{ errors[0] }}</small>
                                        <small class="text-danger" v-if="serverErrors && serverErrors.number">{{
                                            serverErrors.number[0] }}</small>
                                    </validation-provider>
                                </b-form-group>
                            </b-col>
                        </b-row>

                    </b-form>
                </validation-observer>
            </template>
        </b-modal>

        <!-- Form Range Modal -->
        <b-modal id="modal-range-form" ref="myRangeModal" centered no-close-on-backdrop no-close-on-esc size="lg"
            @ok="submitUpdateRange">
            <template #modal-header="{ close }">
                <h5>Edit Range</h5>
                <feather-icon class="ml-4 pr-0 cursor-pointer" icon="XIcon" size="16" @click="close()" />
            </template>

            <template #modal-footer="{ ok, cancel }">
                <b-button size="md" variant="primary" @click="ok()" :disabled="saving">
                    <b-spinner small class="mr-1" label="Small Spinner" v-if="saving" />
                    <span v-if="!saving">Save</span>
                    <span v-if="saving">Saving...</span>
                </b-button>
                <b-button size="md" @click="cancel()" variant="outline-secondary">Cancel</b-button>
            </template>

            <template #default="{ }">
                <b-col cols="12">
                    <b-alert show variant="danger" v-if="errosOcurs">
                        <h4 class="alert-heading">{{ errosOcurs.message }}</h4>
                        <div class="alert-body">
                            <div v-for="(messages, field) in errosOcurs.errors" :key="field">
                                <strong>{{ field }}:</strong>
                                <ul>
                                    <li v-for="message in messages" :key="message">{{ message }}</li>
                                </ul>
                            </div>
                        </div>
                    </b-alert>
                </b-col>

                <validation-observer ref="dataForm" #default="{ invalid }">
                    <b-form ref="form" @submit.stop.prevent="handleCreate">
                        <b-row>
                            <b-col cols="12">
                                <b-form-group labe-for="box_number" label="Box number">
                                    <validation-provider #default="{ errors }" name="Box number" rules="">
                                        <b-form-input id="number" name="number" readonly v-model="range.number"
                                            :state="errors.length > 0 ? false : null" size="md" />
                                        <small class="text-danger">{{ errors[0] }}</small>
                                        <small class="text-danger" v-if="serverErrors && serverErrors.number">{{
                                            serverErrors.number[0] }}</small>
                                    </validation-provider>
                                </b-form-group>
                            </b-col>
                        </b-row>

                        <b-row>
                            <table class="table">
                                <thead>
                                    <tr class="text-center">
                                        <th>Start</th>
                                        <th>End</th>
                                        <th width="10%">Quantity</th>
                                        <th width="3%"></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td><b-form-input id="share" name="start" v-model="range.start" size="md" />
                                        </td>
                                        <td><b-form-input id="share" name="end" v-model="range.end" size="md" /></td>
                                        <td><b-form-input id="quantity" type="number" name="quantity"
                                                v-model="range.quantity" size="md" /></td>
                                    </tr>
                                    <tr>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                    </tr>
                                </tbody>
                            </table>
                        </b-row>

                        <b-row>
                            <b-col cols="12">
                                <b-form-checkbox :checked="range.hasMissing" class="custom-control-success"
                                    name="check-button" switch v-model="range.hasMissing">
                                    <span class="switch-icon-left"><feather-icon icon="CheckCircleIcon" /></span>
                                    <span>Have Missing?</span>
                                </b-form-checkbox>
                            </b-col>
                        </b-row>

                        <b-row v-if="range.hasMissing">
                            <b-col cols="5">
                                <b-form-group labe-for="lastBarcode" label="From Barcode" style="cursor: pointer">
                                    <validation-provider #default="{ errors }" name="lastBarCode" rules="">
                                        <b-form-input id="lastBarcode" name="lastBarcode" v-model="range.lastBarcode"
                                            size="md" />
                                        <small class="text-danger">{{ errors[0] }}</small>
                                        <small class="text-danger" v-if="serverErrors && serverErrors.lastBarcode">{{
                                            serverErrors.lastBarcode[0] }}</small>
                                    </validation-provider>
                                </b-form-group>
                            </b-col>

                            <b-col cols="5">
                                <b-form-group labe-for="direction" label="Direction" style="cursor: pointer">
                                    <validation-provider #default="{ errors }" name="Gender" rules="">
                                        <b-form-select size="md" v-model="range.direction" id="direction"
                                            name="direction" :state="errors.length > 0 ? false : null">
                                            <b-form-select-option :value="null">-- Select --</b-form-select-option>
                                            <b-form-select-option value="1">After</b-form-select-option>
                                            <b-form-select-option value="0">Before</b-form-select-option>
                                        </b-form-select>
                                        <small class="text-danger">{{ errors[0] }}</small>
                                        <small class="text-danger" v-if="serverErrors && serverErrors.direction">{{
                                            serverErrors.direction[0] }}</small>
                                    </validation-provider>
                                </b-form-group>
                            </b-col>

                            <b-col cols="2">
                                <b-form-group labe-for="counts" label="Counts" style="cursor: pointer">
                                    <validation-provider #default="{ errors }" name="count" rules="">
                                        <b-form-input id="count" type="number" name="count" v-model="range.count"
                                            size="md" />
                                        <small class="text-danger">{{ errors[0] }}</small>
                                        <small class="text-danger" v-if="serverErrors && serverErrors.count">{{
                                            serverErrors.count[0] }}</small>
                                    </validation-provider>
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </b-form>
                </validation-observer>
            </template>
        </b-modal>

        <!-- Filters -->
        <b-card no-body>
            <b-card-header class="pb-50">
                <h5>Filter Box based on Location</h5>
            </b-card-header>
            <b-card-body>
                <b-row>
                    <b-col cols="12" md="12" class="mb-md-0 mb-2">
                        <location-filters size="sm" align="horizontal" @filter="changeFilters" />
                    </b-col>
                </b-row>
            </b-card-body>
        </b-card>

        <b-card no-body class="mb-0">
            <div class="m-2">
                <b-row>
                    <b-col cols="12" md="6" class="d-flex align-items-center justify-content-start mb-1 mb-md-0">
                        <label>Show</label>
                        <v-select v-model="perPage" :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                            :options="perPageOptions" :clearable="false"
                            class="per-page-selector d-inline-block mx-50 select-size-sm" />
                        <label>entries</label>
                    </b-col>

                    <b-col cols="12" md="6">
                        <div class="d-flex align-items-center justify-content-end">
                            <b-form-input v-model="searchQuery" class="d-inline-block mr-1" placeholder="Search..."
                                size="sm" />
                            <b-button variant="primary" size="sm" @click="invokeCreateForm()">
                                <span class="text-nowrap">Recieve Box</span>
                            </b-button>
                        </div>
                    </b-col>
                </b-row>
            </div>

            <b-table striped hover small ref="records" class="position-relative" :items="fetch" responsive
                :fields="columns" primary-key="id" :sort-by.sync="sortBy" show-empty empty-text="No records found"
                :sort-desc.sync="isSortDirDesc">
                <template #cell(address)="data">
                    {{ data.item.address ? data.item.address.location.name.toUpperCase() : '' }}
                </template>

                <template #cell(received)="data">
                    <b-badge pill :variant="`light-${resolveStatusVariant(data.item.received)}`" class="text-capitalize">
                        <span v-if="data.item.received == 1">Received</span>
                        <span v-else-if="data.item.received == 0">Not Received</span>
                    </b-badge>
                </template>

                <template #cell(type)="data">
                    <b-badge pill :variant="`light-${resolveTypeVariant(data.item.type)}`" class="text-capitalize">
                        <span v-if="data.item.type == 1">Bale Tickets</span>
                        <span v-else-if="data.item.type == 2">Bale Tags</span>
                        <span v-else>Sweeping Tickets</span>
                    </b-badge>
                </template>

                <template #cell(ranges)="data">
                    <div class="ranges">
                        <table width="100%" class="text-no-wrap">
                            <thead>
                                <tr>
                                    <th class="text-uppercase">Start</th>
                                    <th class="text-uppercase">End</th>
                                    <th class="text-uppercase">Qty</th>
                                    <th class="text-uppercase">Actual Qty</th>
                                    <th class="text-uppercase">Missing</th>
                                    <th class="text-uppercase"></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="rangeItem in data.item.ranges" :key="rangeItem.id">
                                    <td>{{ rangeItem.start }}</td>
                                    <td>{{ rangeItem.end }}</td>
                                    <td>{{ rangeItem.quantity }}</td>
                                    <td>{{ rangeItem.actual }}</td>
                                    <td>{{ rangeItem.missing }}</td>
                                    <td>
                                        <b-button variant="outline-primary" size="sm"
                                            @click="invokeRangeUpdateForm(data.item)">
                                            <feather-icon icon="EditIcon" />
                                        </b-button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </template>
            </b-table>

            <div class="mx-2 mb-2">
                <b-row>
                    <b-col cols="12" sm="6"
                        class="d-flex align-items-center justify-content-center justify-content-sm-start">
                        <span class="text-muted">Showing {{ from }} to {{ to }} of {{ totalRecords }} entries</span>
                    </b-col>

                    <b-col cols="12" sm="6"
                        class="d-flex align-items-center justify-content-center justify-content-sm-end">
                        <b-pagination v-model="currentPage" :total-rows="totalRecords" :per-page="perPage" first-number
                            last-number class="mb-0 mt-1 mt-sm-0" prev-class="prev-item" next-class="next-item">
                            <template #prev-text><feather-icon icon="ChevronLeftIcon" size="18" /></template>
                            <template #next-text><feather-icon icon="ChevronRightIcon" size="18" /></template>
                        </b-pagination>
                    </b-col>
                </b-row>
            </div>
        </b-card>
    </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
    BRow, BCol, BCard, BCardHeader, BCardBody, BTable, BPagination,
    BForm, BFormGroup, BButton, BFormSelect, BFormSelectOption, BFormInput, BDropdown, BDropdownItem,
    BSpinner, BFormCheckbox, BBadge, BAlert, BListGroup, BListGroupItem
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import { required } from '@validations'
import store from '@/store'
import { ref, onUnmounted, onMounted, reactive, watch } from '@vue/composition-api'

import ticketBoxesStoreModule from '@/views/cromis/inventory/ticket_box/ticketBoxesStoreModule'
import useTicketBoxesList from '@/views/cromis/inventory/ticket_box/useTicketBoxesList'
import LocationFilters from '@core/components/cromis/filters/LocationFilters'

export default {
    components: {
        BRow, BCol, BCard, BCardHeader, BCardBody, BTable, BPagination,
        BForm, BFormGroup, BButton, BFormSelect, BFormSelectOption, BFormInput,
        vSelect, BDropdown, BDropdownItem, BSpinner, ValidationObserver, ValidationProvider,
        BFormCheckbox, BBadge, BAlert, BListGroup, BListGroupItem, LocationFilters
    },

    setup(props, context) {
        // --- local mock GRN dataset (no API calls) ---
        const sampleGrnList = [
            {
                grn_number: "MK-26-001",
                boxes: [
                    { id: 1, number: "BOX-1", type: 1 },
                    { id: 2, number: "BOX-2", type: 1 }
                ]
            },
            {
                grn_number: "MK-26-002",
                boxes: [
                    { id: 3, number: "BOX-3", type: 2 },
                    { id: 4, number: "BOX-4", type: 2 }
                ]
            },
            {
                grn_number: "MK-26-003",
                boxes: [
                    { id: 5, number: "BOX-5", type: 1 }
                ]
            }
        ]

        // Refs and reactive state
        const dataForm = ref(null)
        const myModal = ref(null)
        const myRangeModal = ref(null)
        const saving = ref(false)
        const serverErrors = ref(null)
        const selections = ref([])
        const formSelections = ref([])
        const errosOcurs = ref(null)
        const levels = ref(null)
        const companies = ref([])
        const societies = ref([])
        const children = ref([])

        const box = ref({
            id: null,
            number: null,
            grn: null,
            type: null,
            ranges: [],
            action: 'receive',
        })

        const range = ref({
            id: null,
            box_id: null,
            number: null,
            start: null,
            end: null,
            quantity: null,
            hasMissing: false,
            lastBarcode: null,
            direction: null,
            count: null
        })

        // Store module registration
        const CROMIS_STORE_MODULE_NAME = 'cromis-box'
        if (!store.hasModule(CROMIS_STORE_MODULE_NAME)) store.registerModule(CROMIS_STORE_MODULE_NAME, ticketBoxesStoreModule)
        onUnmounted(() => {
            if (store.hasModule(CROMIS_STORE_MODULE_NAME)) store.unregisterModule(CROMIS_STORE_MODULE_NAME)
        })

        // list composable
        const {
            fetch, columns, perPage, currentPage, totalRecords,
            from, to, meta, perPageOptions, searchQuery, sortBy,
            isSortDirDesc, records, refetch, resolveStatusVariant, resolveTypeVariant, locationFilter
        } = useTicketBoxesList()

        // ---------- GRN lookup (local mock, debounced) ----------
        const grnResults = ref([])         // results: array of { id, number, type }
        const grnLoading = ref(false)
        const grnError = ref(null)
        const isBoxNumberLocked = ref(false)
        let grnDebounceTimer = null

        const fetchBoxesByGrnLocal = async (grn) => {
            // no real async call needed, keep same signature for parity
            grnLoading.value = true
            grnError.value = null

            try {
                // simple exact match on grn_number (case-insensitive)
                const found = sampleGrnList.find(item => (item.grn || '').toString().toLowerCase() === (grn || '').toString().toLowerCase())

                if (!found) {
                    grnResults.value = []
                    isBoxNumberLocked.value = false
                } else {
                    // map to only the fields we care about
                    grnResults.value = (found.boxes || []).map(b => ({ id: b.id, number: b.number, type: b.type }))

                    if (grnResults.value.length === 1) {
                        const only = grnResults.value[0]
                        box.value.id = only.id
                        box.value.number = only.number
                        box.value.type = only.type
                        isBoxNumberLocked.value = true
                        // hide suggestions after auto-fill
                        grnResults.value = []
                    } else {
                        // multiple choices; do not lock
                        isBoxNumberLocked.value = false
                    }
                }
            } catch (err) {
                grnError.value = err?.message || 'Failed to search local data'
                grnResults.value = []
                isBoxNumberLocked.value = false
            } finally {
                grnLoading.value = false
            }
        }

        // watch grn_number with debounce
        watch(() => box.value.grn, (newGrn) => {
            if (grnDebounceTimer) clearTimeout(grnDebounceTimer)
            grnDebounceTimer = setTimeout(() => {
                const val = (newGrn || '').toString().trim()
                if (val.length) fetchBoxesByGrnLocal(val)
                else {
                    grnResults.value = []
                    grnError.value = null
                    isBoxNumberLocked.value = false
                }
            }, 400)
        })

        onUnmounted(() => {
            if (grnDebounceTimer) clearTimeout(grnDebounceTimer)
        })

        const selectBoxNumber = (item) => {
            // item: { id, number, type }
            box.value.id = item.id
            box.value.number = item.number
            box.value.type = item.type
            isBoxNumberLocked.value = true
            grnResults.value = []
        }

        // ---------- Form and CRUD methods (kept from original) ----------
        const invokeUpdateForm = (item) => {
            serverErrors.value = null
            errosOcurs.value = null
            box.value = {
                id: item.id,
                type: item.type,
                number: item.number,
                grn: item.number || null,
                ranges: item.ranges || [],
                action: 'receive',
            }
            isBoxNumberLocked.value = !!item.number
            myModal.value.show()
        }

        const invokeCreateForm = () => {
            formSelections.value.map((form) => { form.model = null })
            box.value = { id: null, number: null, grn: null, type: null, ranges: [], action: 'receive' }
            isBoxNumberLocked.value = false
            myModal.value.show()
        }

        const invokeRangeUpdateForm = (par) => {
            formSelections.value.map((form) => { form.model = null })
            range.value = {
                id: par.ranges[0].id,
                box_id: par.id,
                number: par.number,
                start: par.ranges[0].start,
                end: par.ranges[0].end,
                quantity: par.ranges[0].quantity,
                hasMissing: null,
                lastBarcode: null,
                direction: null,
                count: null
            }
            myRangeModal.value.show()
        }

        const isFormValid = async () => {
            let isValid = false
            await dataForm.value.validate().then(success => { isValid = success })
            return isValid
        }

        const submit = (bvModalEvt) => {
            bvModalEvt.preventDefault()
            serverErrors.value = null
            if (box.value.id === null || box.value.id === 0) handleCreate()
            else handleUpdate(box.value)
        }

        const submitUpdateRange = (bvModalEvt) => {
            bvModalEvt.preventDefault()
            serverErrors.value = null
            handleUpdateRange(range.value)
        }

        const handleCreate = async () => {
            saving.value = true
            const valid = await isFormValid()
            if (!valid) { saving.value = false; return }

            await store.dispatch('cromis-box/create', box.value)
                .then(response => {
                    refetch()
                    saving.value = false

                    box.value = {
                        id: null,
                        number: null,
                        grn: null,
                        type: null,
                        ranges: [],
                        action: 'receive',
                    }

                    range.value = {
                        id: null,
                        box_id: null,
                        number: null,
                        start: null,
                        end: null,
                        quantity: null,
                        hasMissing: false,
                        lastBarcode: null,
                        direction: null,
                        count: null
                    }

                    myModal.value.hide()
                    context.root.$swal({ icon: 'success', text: `Box has been added successfully!`, showConfirmButton: true, timer: 3000, customClass: { confirmButton: 'btn btn-primary' }, buttonsStyling: false })
                })
                .catch(error => {
                    saving.value = false
                    errosOcurs.value = error.response?.data
                    if (error.response?.status === 422) serverErrors.value = error.response.data.errors
                    else context.root.$swal({ icon: 'error', title: 'Server Error', text: 'Something went wrong. See tech support', showConfirmButton: true, customClass: { confirmButton: 'btn btn-danger' }, buttonsStyling: false })
                })
        }

        const handleUpdateRange = async (item) => {
            saving.value = true
            const valid = await isFormValid()
            if (!valid) { saving.value = false; return }

            await store.dispatch('cromis-box/range', { id: item.id, data: item })
                .then(response => {
                    refetch()
                    saving.value = false
                    myModal.value.hide()
                    context.root.$swal({ icon: 'success', text: `Changes to box range has been saved successfully!`, showConfirmButton: true, timer: 3000, customClass: { confirmButton: 'btn btn-success' }, buttonsStyling: false })
                })
                .catch(error => {
                    saving.value = false
                    errosOcurs.value = error.response?.data
                    if (error.response?.status === 422) serverErrors.value = error.response.data.errors
                    else context.root.$swal({ icon: 'error', title: 'Server Error', text: 'Something went wrong. See tech support', showConfirmButton: true, customClass: { confirmButton: 'btn btn-danger' }, buttonsStyling: false })
                })
        }

        const handleUpdate = async (item) => {
            saving.value = true
            const valid = await isFormValid()
            if (!valid) { saving.value = false; return }

            await store.dispatch('cromis-box/update', { id: item.id, data: item })
                .then(response => {
                    refetch()
                    saving.value = false

                    box.value = {
                        id: null,
                        number: null,
                        grn: null,
                        type: null,
                        ranges: [],
                        action: 'receive',
                    }

                    range.value = {
                        id: null,
                        box_id: null,
                        number: null,
                        start: null,
                        end: null,
                        quantity: null,
                        hasMissing: false,
                        lastBarcode: null,
                        direction: null,
                        count: null
                    }

                    myModal.value.hide()
                    context.root.$swal({ icon: 'success', text: `Changes to box center ${response.data.code} ${response.data.name} has been saved successfully!`, showConfirmButton: true, timer: 3000, customClass: { confirmButton: 'btn btn-success' }, buttonsStyling: false })
                })
                .catch(error => {
                    saving.value = false
                    errosOcurs.value = error.response?.data
                    if (error.response?.status === 422) serverErrors.value = error.response.data.errors
                    else context.root.$swal({ icon: 'error', title: 'Server Error', text: 'Something went wrong. See tech support', showConfirmButton: true, customClass: { confirmButton: 'btn btn-danger' }, buttonsStyling: false })
                })
        }

        const remove = async (id) => {
            await store.dispatch('cromis-box/remove', id)
                .then(response => { refetch() })
                .catch(error => {
                    context.root.$swal({ icon: 'error', title: 'Server Error', text: 'Something went wrong. See tech support', showConfirmButton: true, customClass: { confirmButton: 'btn btn-danger' }, buttonsStyling: true })
                })
        }

        const changeFilters = async (location) => {
            locationFilter.value = location != null ? location.id : null
        }

        const addElement = () => {
            if (!box.value.ranges) box.value.ranges = []
            box.value.ranges.push({ start: '', end: '', quantity: '' })
        }

        const removeRow = (index) => {
            if (box.value.ranges && box.value.ranges.length > 1) {
                box.value.ranges.splice(index, 1)
                box.value.ranges = box.value.ranges
            }
        }

        return {
            selections, formSelections, levels, children, box, range,
            selectedOwner: null, addedElement: null, clientName: JSON.parse(localStorage.getItem('userData')).client,
            options: [
                { value: null, text: '-- Select Box Type --' },
                { value: '1', text: 'Bale Ticket' },
                { value: '2', text: 'Luggage' },
            ],
            fetch, columns, perPage, currentPage, totalRecords, from, to, meta, perPageOptions, searchQuery, sortBy, isSortDirDesc, records, refetch, resolveStatusVariant, resolveTypeVariant,
            required, saving, serverErrors, dataForm, myModal, myRangeModal, changeFilters,
            invokeCreateForm, invokeUpdateForm, invokeRangeUpdateForm, submit, submitUpdateRange, isFormValid, handleCreate, handleUpdate, handleUpdateRange, remove,
            addElement, removeRow, companies, societies, errosOcurs,

            // GRN lookup exposes
            grnResults, grnLoading, grnError, selectBoxNumber, isBoxNumberLocked
        }
    }
}
</script>

<style>
.add-owner {
    float: right;
}

.ranges {
    max-height: 200px;
    overflow: scroll;
}

/* simple style for suggestion list so it doesn't overlap awkwardly */
.suggestion-list {
    max-height: 180px;
    overflow-y: auto;
    z-index: 1050;
    /* above other UI */
    position: relative;
}
</style>

<style lang="scss" scoped>
@import '@core/scss/vue/libs/vue-select.scss';
</style>
